import { DEFAULT_DIFFICULTY, MAX_DIFFICULTY, MIN_DIFFICULTY } from '../../shared/config';

/** Named points on the 0–100 board difficulty scale; other values show as Custom. */
export const DIFFICULTY_PRESETS: readonly { value: number; label: string }[] = [
  { value: MIN_DIFFICULTY, label: 'Gentle' },
  { value: DEFAULT_DIFFICULTY, label: 'Standard' },
  { value: 40, label: 'Tricky' },
  { value: 70, label: 'Hard' },
  { value: MAX_DIFFICULTY, label: 'Brutal' },
];
